import { assignmentsListingStore } from '@/app/features/assignments/features/assignments-listing/assignments-listing.store';
import { assignmentDetailsStore } from '@/app/features/assignments/features/assignment-details/assignment-details.store';
import { newAssignmentStore } from '@/app/features/assignments/features/new-assignment/new-assignment.store';

export const assignmentsStore = {
  modules: {
    assignmentsListingState: assignmentsListingStore,
    assignmentDetailsState: assignmentDetailsStore,
    newAssignmentState: newAssignmentStore
  }
};
